import styled from 'styled-components';

// The outer element MUST be a <button> for a11y (keyboard/screen-reader), but
// without a reset it picks up the browser's default button chrome — a visible
// rounded gray box behind the three stripes (the 'weird background').
export const HamburgerButtonHost = styled.button`
	background: transparent;
	border: none;
	padding: 0;
	margin: 0;
	font: inherit;
	cursor: pointer;
	-webkit-tap-highlight-color: transparent;

	&:focus {
		outline: 2px solid #c7d4d6;
		outline-offset: 2px;
	}
`;

export const ButtonContainer = styled.div`
	height: 28px;
	width: 28px;
	padding: 6px 4px;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}

	&:active {
		background-color: rgba(255, 255, 255, 0.2);
	}
`;

export const ButtonStripe = styled.div`
	height: 2px;
	width: 100%;
	background-color: #c7d4d6;
	border-radius: 2px;
	transition: transform 0.2s ease;
`;
